export default "__VITE_ASSET__D8vN4ry$__"